import 'moment/locale/ko';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../navigation/AuthProvider';
import moment from 'moment-timezone';
import 'moment/locale/ko';
import DatePicker from 'react-datepicker';
import { addMonths, format, isSameMonth } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  ComposedChart,
  YAxis,
  Line,
} from 'recharts';
import styled from 'styled-components';
import { Link, useOutletContext } from 'react-router-dom';
import OrderController, {
  HotelMonthSummaryType,
  HotelOrderDataType,
  HotelStoreSummaryType,
  HotelStoreTimeSummaryType,
} from '../../controller/OrderController';
import StoreController, {
  CurrentStoreContext,
  DeviceSummaryType,
} from '../../controller/StoreController';

const SalesMonthly = () => {
  const oAuthContext = useContext(AuthContext);

  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const COLORS = ['#00BF96', '#5D61D7', '#FFB53A', '#FF7443', '#838383'];
  const [hotelOrderType, setHotelOrderType] = useState<string>('');
  const [hotelOrderData, setHotelOrderData] = useState<HotelOrderDataType[]>([]);
  const [deviceSummary, setDeviceSummary] = useState<DeviceSummaryType>();
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [hotelStoreSummaryData, setHotelStoreSummaryData] = useState<HotelStoreSummaryType[]>([]);
  const [hotelMonthSummaryData, setHotelMonthSummaryData] = useState<HotelMonthSummaryType>({
    hotel_amount: 0,
    hotel_amount_count: 0,
    room_tip: 0,
    hotel_direct_amount: 0,
    hotel_direct_amount_count: 0,
  });
  const [hotelStoreTimeSummary, setHotelStoreTimeSummary] = useState<HotelStoreTimeSummaryType[]>(
    [],
  );
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  // 달 수익
  const getHotelMonthSummary = async () => {
    let oData: any = {
      user_id: oAuthContext.userInfo.user_id,
      date: moment(selectedDate).format('yyyy-MM'),
    };

    try {
      const oResp = await OrderController.getHotelMonthSummary(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok) {
        setHotelMonthSummaryData(oResponse.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 입점매장 TOP5
  const getHotelStoreSummary = async () => {
    let oData: any = {
      user_id: oAuthContext.userInfo.user_id,
    };

    try {
      const oResp = await OrderController.getHotelStoreSummary(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok) {
        setHotelStoreSummaryData(oResponse.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 객실 기기 관리
  const getDeviceSummary = async () => {
    let oData: any = {
      store_id: currentStore.value,
      user_id: oAuthContext.userInfo.user_id,
    };

    try {
      const oResp = await StoreController.getDeviceSummary(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok) {
        setDeviceSummary(oResponse.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 월간/주간 매출액
  const getHotelOrderData = async () => {
    let oData: any = {
      user_id: oAuthContext.userInfo.user_id,
    };

    try {
      const oResp = await OrderController.getHotelOrderData(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok) {
        if (hotelOrderType === 'month') {
          const monthData = oResponse.data.month.map((item: HotelOrderDataType) => {
            return {
              hotel_amount: Number(item.hotel_amount),
              order_count: item.order_count,
              settlement_date: moment(item.settlement_date).format('MM월'),
            };
          });
          setHotelOrderData(monthData);
        } else if (hotelOrderType === 'week') {
          const weekData = oResponse.data.week.map((item: HotelOrderDataType) => {
            return {
              hotel_amount: Number(item.hotel_amount),
              order_count: item.order_count,
              settlement_date: moment(item.settlement_start_date).format('MM/DD ~'),
            };
          });
          setHotelOrderData(weekData);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 인기시간대
  const getHotelStoreTimeSummary = async () => {
    let oData: any = {
      user_id: oAuthContext.userInfo.user_id,
    };

    try {
      const oResp = await OrderController.getHotelStoreTimeSummary(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok) {
        setHotelStoreTimeSummary(oResponse.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 차트종류
  const renderCustomizedLabel = (oProps: any) => {
    const MAX_LABEL_LENGTH = 7;
    const radius = (oProps.innerRadius + oProps.outerRadius) * 0.8;
    const x =
      oProps.cx +
      (radius * Math.cos(-oProps.midAngle * (Math.PI / 180)) * 600) / (oProps.midAngle + 500);
    const y =
      oProps.cy +
      (radius * Math.sin(-oProps.midAngle * (Math.PI / 180)) * 600) / (oProps.midAngle + 500);

    let displayText = oProps.store_name;
    if (displayText.length > MAX_LABEL_LENGTH) {
      displayText = displayText.substring(0, MAX_LABEL_LENGTH) + '...';
    }
    return (
      <text
        className="sectionLabel"
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central">
        {displayText}
      </text>
    );
  };

  /**
   * 호텔요약 ... (이번달 노크노크 호텔의 예상 수익은 ...)
   *
   * @param oProps
   * @returns
   */
  // 기간조회
  const DashBoardHotelSummary = (oProps: { hotel_name: any }) => {
    return (
      <div className="content monthData">
        <div className="calendarWrap">
          <DatePicker
            id="dateRangePicker"
            className="datePicker"
            onChange={(update: any) => handleDateChange(update)}
            selected={selectedDate}
            dateFormat="yyyy•MM"
            locale="ko"
            showMonthYearPicker
            isClearable={false}
            disabledKeyboardNavigation
            onFocus={(e) => {
              e.preventDefault();
              e.target.blur();
            }}
          />

          <label className="calendar" htmlFor={`dateRangePicker`}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="달력아이콘" />
          </label>
        </div>
        <h1>
          {selectedDate && isSameMonth(selectedDate, new Date())
            ? '이번달 '
            : moment(selectedDate).format('YY년 MM월 ')}
          {oProps.hotel_name}의
          <br />
          예상 수익은
          <span>
            {(
              hotelMonthSummaryData.hotel_direct_amount +
              hotelMonthSummaryData.room_tip +
              hotelMonthSummaryData.hotel_amount
            ).toLocaleString()}
            원
          </span>
          입니다
        </h1>
        {/* <div className="analysisContainer">
          <h3>
            지난달 대비 <span>200,000원 증가</span>
          </h3>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_up_red.svg`} alt="ic" />
        </div> */}
        <div className="boxContainer">
          <div className="box">
            <h4>직영매장 매출</h4>
            <h2>{hotelMonthSummaryData.hotel_direct_amount.toLocaleString()}원</h2>
          </div>
          <div className="box">
            <h4>객실관리팁 매출</h4>
            <h2>{hotelMonthSummaryData.room_tip.toLocaleString()}원</h2>
          </div>
          <div className="box">
            <h4>외부매장 배달수익</h4>
            <h2>{hotelMonthSummaryData.hotel_amount.toLocaleString()}원</h2>
          </div>
          <div className="box">
            <h4>배달 건수</h4>
            <h2>{hotelMonthSummaryData.hotel_amount_count.toLocaleString()}개</h2>
          </div>
        </div>
      </div>
    );
  };

  /**
   * 인기매장 TOP 5
   *
   * @param oProps
   * @returns
   */
  const DashBoardRankStore = (oProps: { hotelStoreSummaryData: HotelStoreSummaryType[] }) => {
    return (
      <div className="content">
        <h2>인기매장 TOP 5</h2>
        <ResponsiveContainer className="pieChart" width={'100%'} height={178}>
          <PieChart>
            <Pie
              data={oProps.hotelStoreSummaryData}
              dataKey="order_count"
              cx="50%"
              cy="50%"
              outerRadius={'100%'}
              label={renderCustomizedLabel}
              labelLine={false}
              startAngle={90}
              endAngle={450}>
              {oProps.hotelStoreSummaryData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        {hotelStoreSummaryData.length > 0 &&
          hotelStoreSummaryData.map((data: any, index: number) => (
            <div className="summaryDataList">
              <div
                className="circle"
                style={{
                  backgroundColor:
                    index === 0
                      ? '#00bf96'
                      : index === 1
                      ? '#5D61D7'
                      : index === 2
                      ? '#FFB53A'
                      : index === 3
                      ? '#FF7443'
                      : index === 4
                      ? '#838383'
                      : '#00bf96',
                }}></div>
              <p>{data.store_name}</p>
              <p>{data.order_count}건</p>
              <p>{Number(data.hotel_amount).toLocaleString()}원</p>
            </div>
          ))}
      </div>
    );
  };

  /**
   * 객실 기기 관리
   *
   * @param oProps
   * @returns
   */
  const DashBoardDeviceSummary = (oProps: { deviceSummary: DeviceSummaryType | undefined }) => {
    return (
      <div className="content deviceWrap">
        <div className="title">
          <h2>객실 기기 관리</h2>
          <Link to={'/room/device'}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right.svg`} alt="ic" width={26} />
          </Link>
        </div>
        <div className="deviceBox">
          <h3>총 기기수</h3>
          <h2>{oProps.deviceSummary?.total_count}개</h2>
        </div>
        <div className="boxflex">
          <div className="deviceBox">
            <h3>정상 작동중</h3>
            <h2>{oProps.deviceSummary?.normal_count}개</h2>
          </div>
          <div className="deviceBox">
            <h3>이상 있음</h3>
            <h2 className="error">{oProps.deviceSummary?.abnormal_count}개</h2>
          </div>
        </div>
      </div>
    );
  };

  /**
   * 월간/주간 매출,주문
   *
   * @param oProps
   * @returns
   */
  const DashBoardDateSummary = (oProps: {
    hotelOrderData: HotelOrderDataType[];
    hotelOrderType: string;
  }) => {
    return (
      <div className="content btnTrue">
        <h2>통합 매출•주문</h2>
        <ResponsiveContainer width="100%" height="100%" aspect={5.0 / 3.0}>
          <ComposedChart
            data={oProps.hotelOrderData}
            margin={{
              top: 40,
              right: 0,
              bottom: 0,
              left: 0,
            }}>
            <CartesianGrid stroke="rgba(229, 229, 229, 0.4)" vertical={false} />
            <XAxis
              dataKey="settlement_date"
              axisLine={false}
              tick={{ fill: '#9F9F9F', fontSize: 12 }}
              tickLine={false}
            />
            <YAxis
              type="number"
              yAxisId="left"
              tick={{ fill: '#9F9F9F', fontSize: 12 }}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              tickFormatter={(value) => `${value}건`}
              tick={{ fill: '#9F9F9F', fontSize: 12 }}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip />
            <Legend />
            <Bar
              name="주문건수"
              dataKey="order_count"
              barSize={16}
              fill="#4DD2AE"
              yAxisId="right"
            />
            <Line
              name="매출"
              type="monotone"
              dataKey="hotel_amount"
              strokeWidth={3}
              stroke="#3380F5"
              yAxisId="left"
            />
          </ComposedChart>
        </ResponsiveContainer>
        <div className="sortButtonWrap">
          <button
            onClick={() => setHotelOrderType('month')}
            className={` ${oProps.hotelOrderType === 'month' ? 'activeBtn' : 'btn'}`}>
            월간
          </button>
          <button
            onClick={() => setHotelOrderType('week')}
            className={` ${oProps.hotelOrderType === 'week' ? 'activeBtn' : 'btn'}`}>
            주간
          </button>
        </div>
      </div>
    );
  };

  /**
   * 인기 시간대
   *
   * @param oProps
   * @returns
   */
  const DashBoardTimeSummary = (oProps: { hotelStoreTimeSummary: HotelStoreTimeSummaryType[] }) => {
    return (
      <div className="content btnTrue">
        <h2>인기 시간대</h2>
        <ResponsiveContainer className={'chart'} width="100%" height="100%" aspect={5.0 / 3.0}>
          <BarChart
            data={oProps.hotelStoreTimeSummary}
            margin={{ top: 30, right: 0, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="rgba(229, 229, 229, 0.4)" vertical={false} />
            <XAxis
              axisLine={false}
              dataKey="hour"
              name="시간"
              tickFormatter={(value) => `${value}시`}
              tick={{ fill: '#9F9F9F', fontSize: 10 }}
              tickLine={false}
            />
            <YAxis
              axisLine={false}
              tick={{ fill: '#9F9F9F', fontSize: 12 }}
              tickLine={false}
              tickFormatter={(value) => `${value}건`}
            />
            <Tooltip />
            <Bar dataKey="order_count" name="주문건수" fill="#FFB53A" />
          </BarChart>
        </ResponsiveContainer>
        <div className="sortButtonWrap weekTime">최근 7일</div>
      </div>
    );
  };

  useEffect(() => {
    if (hotelOrderType) {
      getHotelOrderData();
    }
  }, [hotelOrderType]);
  useEffect(() => {
    setHotelOrderType('month');
    getHotelStoreSummary();
    getHotelStoreTimeSummary();
    getHotelMonthSummary();
    getDeviceSummary();
  }, [oAuthContext.userInfo.user_id]);

  useEffect(() => {
    getHotelMonthSummary();
  }, [selectedDate]);

  return (
    <Style>
      <div className="wideContainer">
        <div className="topContainer">
          {/* 이번달 노크노크호텔의 예상 수익은 ... */}
          <DashBoardHotelSummary hotel_name={oAuthContext.currentStore.name} />

          {/* 인기매장 TOP 5 */}
          <DashBoardRankStore hotelStoreSummaryData={hotelStoreSummaryData} />

          {/* 객실 기기 관리 */}
          <DashBoardDeviceSummary deviceSummary={deviceSummary} />
        </div>
        <div className="bottomContainer">
          {/* 매출,주문 (월간,주간) */}
          <DashBoardDateSummary hotelOrderData={hotelOrderData} hotelOrderType={hotelOrderType} />

          {/* 인기 시간대 */}
          <DashBoardTimeSummary hotelStoreTimeSummary={hotelStoreTimeSummary} />
        </div>
      </div>
    </Style>
  );
};

export default SalesMonthly;

const Style = styled.div`
  /* 공통 */
  h1 {
    font-size: 32px;
    font-weight: 600;
    color: #555555;
    line-height: 48px;
  }
  h2 {
    font-size: 20px;
    font-weight: 600;
    color: #555;
  }
  span {
    margin: 0 6px;
    color: #4dd2ae;
  }

  /* wideContainer */
  .wideContainer {
    width: 100%;
    max-width: 100%;
    height: calc(100vh - 54px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
  }
  /* Container */
  .topContainer,
  .bottomContainer {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 2%;
  }
  .content {
    flex: 1;
    padding: 29px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px #0000001a;

    .title {
      display: flex;
      align-items: center;
    }
  }
  .topContainer .content:nth-child(1) {
    flex: 2;
  }

  /* 이번달 매출 */
  .monthData {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .boxContainer {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 10px;

    .box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 30px 12px;
      border: 1px solid #dddddd;
      border-radius: 10px;

      h2 {
        margin-bottom: 0;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        color: #555555;
      }
      h4 {
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 400;
        color: #979797;
        text-align: center;
      }
    }
  }
  .analysisContainer {
    display: flex;
    align-items: center;
    margin: 16px 0 25px 0;

    h3 {
      font-size: 16px;
      font-weight: 500;
      color: #a7a7a7;
    }
    span {
      color: #ff6464;
    }
  }

  /* 인기매장Top5 */
  .pieChart {
    margin: 10px 0;
  }
  .summaryDataList {
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    .circle {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #00bf96;
    }
    p {
      font-size: 12px;
      font-weight: 500;
      color: #555;
    }
    p:nth-child(2) {
      flex: 1;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    p:nth-child(3) {
      width: 15%;
      text-align: center;
    }
    p:nth-child(4) {
      width: 20%;
      text-align: center;
    }
  }
  .sectionLabel {
    font-size: 10px;
    max-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* 객실기기관리 */
  .deviceWrap {
    h2 {
      font-size: 20px;
      font-weight: 600;
      color: #555555;
    }
    h3 {
      margin-bottom: 12px;
      font-size: 16px;
      font-weight: 400;
      color: #979797;
      white-space: nowrap;
    }
    .error {
      color: #ff6060;
    }
    .title,
    .boxflex {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .deviceBox {
      margin-top: 18px;
      padding: 30px;
      border: 1px solid #dddddd;
      border-radius: 10px;
      text-align: center;
    }
    .boxflex {
      gap: 8px;
      .deviceBox {
        flex: 1;
      }
    }
  }

  /* 그래프 */
  .chart {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
  /* 월간/주간 버튼 */
  .btnTrue {
    position: relative;
  }
  .sortButtonWrap {
    position: absolute;
    top: 20px;
    right: 30px;
    display: flex;
    align-items: center;
    gap: 10px;

    button {
      padding: 7px 20px 6px 20px;
      border-radius: 5px;
      background: #fff;
      font-size: 16px;
      font-weight: 600;
      border: 1px solid #cecece;
      color: #555;
    }
    button.activeBtn {
      background: #4dd2ae;
      color: #fff;
      border-color: #4dd2ae;
    }
  }
  .weekTime {
    padding: 7px 14px 6px 14px;
    border-radius: 5px;
    background: #ffb53a;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    border: 1px solid #ffb53a;
  }

  /* react-datepicker */
  .calendarWrap {
    position: relative;
    width: 100%;
    .calendar {
      position: absolute;
      left: 100px;
      top: 12px;
    }
  }
  .react-datepicker {
    display: flex;
  }
  .datePicker {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 9px 0;
    padding-right: 30px;
    border-radius: 5px;
    border: none;
    color: #a7a7a7;
    font-weight: 600;
    font-size: 22px;
    cursor: pointer;
    letter-spacing: 0.5px;
    input {
      display: none;
    }
  }

  @media (max-width: 1400px) {
    .wideContainer {
      min-height: calc(100vh - 54px);
    }
    h1 {
      font-size: 28px;
      line-height: 38px;
    }
    .monthData .boxContainer {
      flex-wrap: wrap;
      .box {
        min-width: 48%;
        padding: 12px;
      }
    }
    .deviceWrap .deviceBox {
      padding: 30px 10px;
    }
  }
  @media (max-width: 1400px) {
    h1 {
      margin-bottom: 12px;
      font-size: 22px;
      line-height: 30px;
    }
    .wideContainer {
      min-height: auto;
      height: auto;
    }
    .topContainer,
    .bottomContainer {
      flex-direction: column;
    }
    .content {
      margin: 15px;
    }
  }
  @media (max-width: 900px) {
    .wideContainer {
      /* background: #f7f7f7; */
    }
    .content {
      border-top: 6px solid #f7f7f7;
      border: none;
      box-shadow: none;
      padding: 0;
    }
  }
`;
